export default "__VITE_ASSET__DC_62gr$__"